import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, HelpCircle, ChevronDown, ShoppingCart, CreditCard, RefreshCw, Shield, Link2, MessageCircle, Send } from 'lucide-react';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqSection {
  title: string;
  icon: React.ElementType;
  items: FaqItem[];
}

const FAQ_SECTIONS: FaqSection[] = [
  {
    title: 'Покупка скинов',
    icon: ShoppingCart,
    items: [
      {
        q: 'Как купить скин на Xpanda Market?',
        a: '1. Войдите через Steam, нажав кнопку «Войти» в правом верхнем углу.\n2. Укажите ваш Steam Trade URL в профиле (Настройки > Trade URL).\n3. Пополните баланс любым удобным способом.\n4. Найдите нужный скин через каталог или поиск.\n5. Нажмите «Купить» и подтвердите покупку.\n6. Примите трейд-предложение в Steam.',
      },
      {
        q: 'Сколько времени занимает доставка скина?',
        a: 'Обычно скин доставляется в течение 1-15 минут после покупки. Трейд-предложение приходит автоматически в Steam. В редких случаях (высокая нагрузка на площадки) доставка может занять до 30 минут.',
      },
      {
        q: 'Что делать, если скин не пришёл?',
        a: 'Проверьте входящие трейд-предложения в Steam. Убедитесь, что ваш Trade URL актуален. Если трейд не пришёл в течение 30 минут — обратитесь в поддержку по адресу site@xpanda.team с указанием номера заказа.',
      },
      {
        q: 'Можно ли отменить покупку?',
        a: 'После подтверждения оплаты отмена невозможна, если трейд уже отправлен. Если трейд ещё не был создан — покупка может быть отменена автоматически в случае недоступности товара, и средства будут возвращены.',
      },
      {
        q: 'Что означают Float, Pattern и наклейки?',
        a: 'Float (износ) — числовое значение от 0 до 1, определяющее степень износа скина. Чем ниже — тем лучше состояние.\nPattern (seed) — уникальный шаблон рисунка. Некоторые паттерны ценятся выше (например, \"blue gem\" у Case Hardened).\nНаклейки — стикеры, нанесённые на оружие. Редкие наклейки могут значительно повышать стоимость скина.\n\nЭти данные отображаются, когда они доступны от поставщика. Не все торговые площадки передают inspect-данные.',
      },
    ],
  },
  {
    title: 'Оплата',
    icon: CreditCard,
    items: [
      {
        q: 'Какие способы оплаты доступны?',
        a: 'Оплата производится через СБП (Систему быстрых платежей) с помощью QR-кода. После оформления покупки откроется QR-код — отсканируйте его в приложении вашего банка для подтверждения оплаты.',
      },
      {
        q: 'Как быстро проходит оплата?',
        a: 'При оплате картой или через СБП средства обрабатываются моментально. После успешной оплаты система сразу начинает поиск скина у поставщиков.',
      },
      {
        q: 'Можно ли получить возврат средств?',
        a: 'Если скин не был доставлен по техническим причинам, средства возвращаются автоматически. Для других случаев обратитесь в поддержку: site@xpanda.team.',
      },
    ],
  },
  {
    title: 'Статусы заказов',
    icon: RefreshCw,
    items: [
      {
        q: 'Что означают статусы заказа?',
        a: '• В обработке — оплата прошла, система ищет товар у поставщиков.\n• Трейд отправлен — предложение обмена отправлено в Steam, примите его.\n• Выполнено — скин успешно доставлен.\n• Ошибка — что-то пошло не так, средства будут возвращены.',
      },
      {
        q: 'Заказ завершился с ошибкой. Что делать?',
        a: 'Ошибки бывают двух типов:\n\n• Системные (таймаут трейда, скин недоступен) — попробуйте повторить покупку.\n• Требующие действия (невалидный Trade URL, приватный инвентарь) — проверьте настройки Steam и повторите попытку.\n\nСредства при ошибке возвращаются автоматически.',
      },
    ],
  },
  {
    title: 'Настройки Steam',
    icon: Link2,
    items: [
      {
        q: 'Где взять Trade URL?',
        a: 'Откройте Steam → Инвентарь → Предложения обмена → «Кто может отправлять мне предложения обмена?» — скопируйте ссылку. Или перейдите по адресу: https://steamcommunity.com/my/tradeoffers/privacy#trade_offer_access_url',
      },
      {
        q: 'Почему важно, чтобы инвентарь был публичным?',
        a: 'Для доставки скина через Steam Trade наш бот должен видеть ваш инвентарь. Откройте Steam → Настройки приватности → Инвентарь → «Публичный». После получения скина можно вернуть приватность.',
      },
    ],
  },
  {
    title: 'Безопасность',
    icon: Shield,
    items: [
      {
        q: 'Безопасно ли покупать на Xpanda Market?',
        a: 'Да. Мы используем официальный Steam OpenID для авторизации — ваш пароль нам недоступен. Оплата проходит через проверенные платёжные системы. Все сделки проводятся через Steam Trade Offers с подтверждением.',
      },
      {
        q: 'Вы храните мой пароль Steam?',
        a: 'Нет. Авторизация происходит через официальный Steam OpenID. Мы получаем только публичную информацию: Steam ID, никнейм и аватар.',
      },
    ],
  },
  {
    title: 'Поддержка',
    icon: MessageCircle,
    items: [
      {
        q: 'Как связаться с поддержкой?',
        a: 'Напишите на site@xpanda.team с описанием проблемы и номером заказа (если применимо). Среднее время ответа — до 24 часов.',
      },
      {
        q: 'У меня проблема, которой нет в FAQ',
        a: 'Напишите в поддержку на site@xpanda.team. Укажите ваш Steam ID, описание проблемы и скриншоты, если есть. Мы поможем разобраться.',
      },
    ],
  },
];

function Accordion({ item }: { item: FaqItem }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#30363d] last:border-0">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-4 text-left group"
      >
        <span className="text-white font-medium pr-4 group-hover:text-[#ff6b00] transition-colors">{item.q}</span>
        <ChevronDown className={`w-5 h-5 text-[#8b949e] shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="pb-4 text-[#8b949e] text-sm whitespace-pre-line leading-relaxed">
          {item.a}
        </div>
      )}
    </div>
  );
}

export function FaqPage() {
  return (
    <div className="min-h-screen bg-[#0d1117] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back button */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#8b949e] hover:text-[#ff6b00] transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Назад на маркет</span>
        </Link>

        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <HelpCircle className="w-8 h-8 text-[#ff6b00]" />
          <h1 className="text-3xl font-bold text-white">Часто задаваемые вопросы</h1>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {FAQ_SECTIONS.map((section) => {
            const Icon = section.icon;
            return (
              <div key={section.title} className="bg-[#161b22] rounded-xl border border-[#30363d] overflow-hidden">
                <div className="flex items-center gap-3 px-6 py-4 border-b border-[#30363d] bg-[#0d1117]/50">
                  <Icon className="w-5 h-5 text-[#ff6b00]" />
                  <h2 className="text-lg font-semibold text-white">{section.title}</h2>
                </div>
                <div className="px-6">
                  {section.items.map((item, i) => (
                    <Accordion key={i} item={item} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Contact CTA */}
        <div className="mt-8 bg-[#161b22] rounded-xl border border-[#30363d] p-6 text-center">
          <p className="text-white font-medium mb-2">Не нашли ответ?</p>
          <p className="text-[#8b949e] text-sm mb-4">Напишите в поддержку — мы поможем разобраться.</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <a
              href="mailto:site@xpanda.team"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-[#ff6b00] text-white font-semibold rounded-lg hover:bg-[#ff8533] transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              site@xpanda.team
            </a>
            <a
              href="https://t.me/xpanda_support"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-2.5 border border-[#30363d] text-white font-semibold rounded-lg hover:bg-[#1a2332] transition-colors"
            >
              <Send className="w-4 h-4" />
              Telegram
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
